if (!customElements.get('product-description-accordions')) {
  customElements.define(
    'product-description-accordions',
    class ProductDescriptionAccordions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        const source = this.querySelector('[data-description-source]');
        if (!source) return;

        const targets = {
          detail: this.querySelector('[data-description-target="detail"]'),
          quality: this.querySelector('[data-description-target="quality"]'),
          'size-guide': this.querySelector('[data-description-target="size-guide"]'),
        };
        const productInfo = this.closest('product-info');
        const colorRow = productInfo?.querySelector('[data-product-color-row]');
        const colorValue = colorRow?.querySelector('[data-product-color-value]');

        let currentTarget = targets.detail;

        Array.from(source.childNodes).forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(node.tagName)) {
            const heading = node.textContent.trim().toLowerCase();

            if (heading === 'color' || heading === 'colour' || heading === 'カラー') {
              currentTarget = colorValue;
              return;
            }

            if (heading === 'detail' || heading === 'details') {
              currentTarget = targets.detail;
              return;
            }

            if (heading === 'quality') {
              currentTarget = targets.quality;
              return;
            }

            if (heading === 'size' || heading === 'size guide' || heading === 'size chart') {
              currentTarget = targets['size-guide'];
              return;
            }
          }

          if (currentTarget) currentTarget.appendChild(node);
        });

        source.remove();
        if (colorRow && colorValue?.textContent.trim()) colorRow.hidden = false;
        this.dataset.initialized = 'true';
      }
    }
  );
}
